import { render, staticRenderFns } from "./StudentTestLoadWidget.vue?vue&type=template&id=5a72e6d0"
import script from "./StudentTestLoadWidget.vue?vue&type=script&lang=js"
export * from "./StudentTestLoadWidget.vue?vue&type=script&lang=js"
import style0 from "./StudentTestLoadWidget.vue?vue&type=style&index=0&id=5a72e6d0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a72e6d0')) {
      api.createRecord('5a72e6d0', component.options)
    } else {
      api.reload('5a72e6d0', component.options)
    }
    module.hot.accept("./StudentTestLoadWidget.vue?vue&type=template&id=5a72e6d0", function () {
      api.rerender('5a72e6d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/report_widgets/StudentTestLoadWidget.vue"
export default component.exports